// Translations DE / EN / ES — Schweizer Planmanufaktur GmbH (industrial assembly partner)
export const translations = {
  de: {
    nav: {
      services: "Leistungen",
      industries: "Branchen",
      process: "Ablauf",
      models: "Servicemodelle",
      about: "Über uns",
      contact: "Kontakt",
      cta: "Anfrage stellen",
    },
    hero: {
      eyebrow: "MONTAGEPARTNER · DE · CH · INTERNATIONAL",
      title_1: "Montieren.",
      title_2: "Bauen.",
      title_3: "Warten.",
      subtitle:
        "Wir sind die kleine Manufaktur für grosse Anlagen — Spezialisten für Getränkeabfüllung auf Krones-, KHS- und Tanner-Linien. Für Brauereien, Soft-Drink-Produzenten und Mineralwasserabfüller. In der Schweiz, in Deutschland, in Übersee.",
      cta_primary: "Projekt anfragen",
      cta_secondary: "Leistungen ansehen",
      stat_1_value: "3",
      stat_1_label: "Festangestellte Monteure",
      stat_2_value: "15+",
      stat_2_label: "Jahre Erfahrung",
      stat_3_value: "4",
      stat_3_label: "Kontinente im Einsatz",
      stat_4_value: "24/7",
      stat_4_label: "Reaktion bei Stillstand",
    },
    services: {
      eyebrow: "LEISTUNGEN · 06 KOMPETENZEN",
      title: "Von der Schraube bis zur kompletten Linie.",
      lead: "Ob Neumontage einer Abfüllanlage, Generalüberholung einer Werkzeugmaschine oder kurzfristige Wartung im Schichtbetrieb — wir liefern Hand, Werkzeug und Verstand.",
      items: [
        { code: "01", name: "Neumontagen", desc: "Komplettmontage von Abfüll-, Verpackungs- und Werkzeugmaschinen direkt beim Endkunden." },
        { code: "02", name: "Wartung", desc: "Geplante Wartung nach Herstellervorgabe — terminsicher, dokumentiert, im Schichtbetrieb." },
        { code: "03", name: "Revisionen", desc: "Generalüberholungen mit Demontage, Tausch, Justage und Wiederinbetriebnahme." },
        { code: "04", name: "Anpassungen", desc: "Umbauten, Formatwechsel und Retrofits — schnell, sauber, dokumentiert." },
        { code: "05", name: "Inbetriebnahmen", desc: "Begleitung von Cold Tests, Hot Tests und SAT-Abnahmen weltweit." },
        { code: "06", name: "Servicepartnerschaft", desc: "Dauerhafte Bereitstellung erfahrener Monteure für OEM und Endkunde." },
      ],
    },
    industries: {
      eyebrow: "BRANCHEN · 02 KERNGEBIETE",
      title: "Zwei Welten, ein Anspruch: Präzision unter Druck.",
      cards: [
        {
          tag: "BRANCHE 01",
          name: "Getränkeindustrie",
          desc: "Krones, KHS, Tanner — wir kennen die grossen Hersteller und ihre Linien. Für Brauereien, Soft-Drink-Produzenten und Mineralwasserabfüller weltweit im Einsatz: Neumontagen, geplante Revisionen, kritische Wartungseinsätze.",
          bullets: ["Krones · KHS · Tanner", "Brauerei · Soft Drinks · Wasser", "Streckblasen · Abfüllen · Etikettieren", "Troubleshooting unter Zeitdruck"],
          img: "https://images.unsplash.com/photo-1559059699-085698eba48c?auto=format&fit=crop&w=1400&q=80",
        },
        {
          tag: "BRANCHE 02",
          name: "Werkzeugmaschinen",
          desc: "Aufbau, Justage und Anpassung von Dreh-, Fräs- und Bearbeitungszentren. Mit dem Blick fürs Detail — und dem Auge für Mikrometer.",
          bullets: ["Dreh- & Fräszentren", "Schleif- & Erodiermaschinen", "Roboter-Integration", "Geometrische Vermessung"],
          img: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1400&q=80",
        },
      ],
    },
    process: {
      eyebrow: "ABLAUF · IN VIER SCHRITTEN",
      title: "Klar definiert. Sauber ausgeführt.",
      steps: [
        { code: "01", name: "Anfrage", desc: "Sie nennen Anlage, Standort und Zeitfenster. Wir antworten verbindlich innerhalb 24 Stunden." },
        { code: "02", name: "Planung", desc: "Wir definieren Team, Werkzeug und Logistik. Reisen, Visa und Sicherheitsunterweisungen organisieren wir." },
        { code: "03", name: "Einsatz", desc: "Unser Team ist auf der Baustelle. Tagesberichte, klare Eskalationswege, sauberes Auftreten." },
        { code: "04", name: "Übergabe", desc: "Dokumentierte Abnahme, Mängelliste abgearbeitet, Hand­over an Betrieb oder OEM." },
      ],
    },
    models: {
      eyebrow: "SERVICEMODELLE · TRANSPARENT",
      title: "Drei Wege, mit uns zu arbeiten.",
      lead: "Vom punktuellen Einsatz bis zum festen Stammteam — wir skalieren mit Ihrem Bedarf.",
      plans: [
        {
          name: "Spot-Einsatz",
          price: "ab CHF 990",
          unit: "/ Tag",
          desc: "Einmalige Montage, Wartung oder Revision — kurzfristig, ohne Bindung.",
          features: ["Reaktion < 72 h", "1–6 Monteure", "Werkzeug & Logistik inkl.", "Tagesberichte"],
        },
        {
          name: "Rahmenvertrag",
          price: "Individuell",
          unit: "",
          desc: "Wiederkehrende Wartungen oder geplante Revisionsfenster, fixe Stundensätze.",
          features: ["Servicekalender", "Bevorzugte Verfügbarkeit", "Quartalsreporting", "Eskalationspfad 24/7"],
          featured: true,
        },
        {
          name: "Stammteam",
          price: "Auf Anfrage",
          unit: "",
          desc: "Dauerhaft eingesetzte Monteure als Verlängerung Ihrer Service-Organisation.",
          features: ["Dediziertes Team", "OEM-Schulungen", "Internationale Reisebereitschaft", "Mehrsprachig: DE · EN · ES"],
        },
      ],
    },
    about: {
      eyebrow: "ÜBER UNS · SCHWEIZER PLANMANUFAKTUR GMBH",
      title: "Drei Monteure. 15 Jahre. Vier Kontinente.",
      p1: "Wir sind eine kleine Manufaktur mit drei festangestellten Monteuren — geschult in Schlosserei, Montage und Elektrik, alle mit über 15 Jahren internationaler Erfahrung in der Getränkeabfülltechnologie. Spezialisiert auf Anlagen von Krones, KHS und Tanner.",
      p2: "Wir arbeiten als Troubleshooter und Problemlöser bei Neumontagen, Wartungen und Revisionen — in der Schweiz, in Deutschland und überall, wo namhafte Brauereien, Soft-Drink-Produzenten oder Mineralwasserabfüller uns brauchen. Auch in Amerika, Australien oder Afrika. Kein Brokerage, keine Subkontraktoren — drei Hände, die wissen, was sie tun.",
      bullet_1: "Krones · KHS · Tanner-erfahren",
      bullet_2: "DE · CH · Amerika · Asien · Afrika",
      bullet_3: "Werkzeug, Reise & Logistik inklusive",
    },
    contact: {
      eyebrow: "KONTAKT · UNVERBINDLICH",
      title: "Wann soll Ihr Team vor Ort sein?",
      lead: "Schreiben Sie uns Anlage, Ort und Wunschtermin. Wir antworten innerhalb eines Werktags mit Verfügbarkeit und Tagessatz.",
      fields: {
        name: "Name",
        email: "E-Mail",
        phone: "Telefon",
        company: "Firma",
        project_type: "Einsatzart",
        message: "Anlage, Standort, Zeitfenster",
      },
      submit: "Anfrage senden",
      submitting: "Wird gesendet…",
      success: "Danke! Wir melden uns innerhalb von 24 Stunden.",
      error: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
      info_title: "Hauptsitz",
      info_address: "Gründenstrasse 82, 8247 Flurlingen",
      info_hours: "Mo – Fr · 07:00 – 18:00 · Notfall 24/7",
      info_phone: "+41 52 000 00 00",
      info_email: "kontakt@schweizer-planmanufaktur.ch",
    },
    footer: {
      tagline: "Schweizer Planmanufaktur GmbH · Montieren, Bauen, Warten.",
      rights: "Alle Rechte vorbehalten.",
      imprint: "Impressum",
      privacy: "Datenschutz",
    },
    projectTypes: {
      "new-installation": "Neumontage",
      "maintenance": "Wartung",
      "overhaul": "Revision",
      "modification": "Umbau / Anpassung",
      "commissioning": "Inbetriebnahme",
      "service-partnership": "Servicepartnerschaft",
      "other": "Sonstiges",
    },
  },
  en: {
    nav: {
      services: "Services",
      industries: "Industries",
      process: "Process",
      models: "Engagements",
      about: "About",
      contact: "Contact",
      cta: "Start a project",
    },
    hero: {
      eyebrow: "ASSEMBLY PARTNER · DE · CH · INTERNATIONAL",
      title_1: "Assemble.",
      title_2: "Build.",
      title_3: "Maintain.",
      subtitle:
        "We are the small workshop for big plants — specialists for beverage filling on Krones, KHS and Tanner lines. For breweries, soft-drink producers and mineral-water bottlers. In Switzerland, in Germany, overseas.",
      cta_primary: "Start a project",
      cta_secondary: "See services",
      stat_1_value: "3",
      stat_1_label: "In-house fitters",
      stat_2_value: "15+",
      stat_2_label: "Years of experience",
      stat_3_value: "4",
      stat_3_label: "Continents served",
      stat_4_value: "24/7",
      stat_4_label: "Response on stoppage",
    },
    services: {
      eyebrow: "SERVICES · 06 CAPABILITIES",
      title: "From the single bolt to the full line.",
      lead: "Whether the new build of a bottling line, the overhaul of a machine tool or quick maintenance on shift — we bring hand, tool and head.",
      items: [
        { code: "01", name: "New installations", desc: "Complete on-site assembly of bottling, packaging and machine-tool equipment." },
        { code: "02", name: "Maintenance", desc: "Scheduled maintenance to OEM specifications — on time, documented, shift-ready." },
        { code: "03", name: "Overhauls", desc: "Full overhauls with disassembly, replacement, alignment and re-commissioning." },
        { code: "04", name: "Modifications", desc: "Format changes, retrofits and rebuilds — fast, clean, documented." },
        { code: "05", name: "Commissioning", desc: "Cold tests, hot tests and SAT acceptance support worldwide." },
        { code: "06", name: "Service partnership", desc: "Long-term provisioning of seasoned fitters for OEMs and end customers." },
      ],
    },
    industries: {
      eyebrow: "INDUSTRIES · 02 CORE FIELDS",
      title: "Two worlds, one standard: precision under pressure.",
      cards: [
        {
          tag: "FIELD 01",
          name: "Beverage industry",
          desc: "Krones, KHS, Tanner — we know the major OEMs and their lines. Deployed worldwide for breweries, soft-drink producers and mineral-water bottlers: new installations, scheduled overhauls, critical maintenance windows.",
          bullets: ["Krones · KHS · Tanner", "Breweries · Soft drinks · Water", "Stretch-blow · Filling · Labelling", "Troubleshooting under pressure"],
          img: "https://images.unsplash.com/photo-1559059699-085698eba48c?auto=format&fit=crop&w=1400&q=80",
        },
        {
          tag: "FIELD 02",
          name: "Machine tools",
          desc: "Assembly, alignment and modification of turning, milling and machining centres. Down to the micron.",
          bullets: ["Turning & milling centres", "Grinding & EDM", "Robot integration", "Geometric measurement"],
          img: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1400&q=80",
        },
      ],
    },
    process: {
      eyebrow: "PROCESS · FOUR STEPS",
      title: "Clearly defined. Cleanly executed.",
      steps: [
        { code: "01", name: "Request", desc: "Tell us asset, site and time window. We respond firmly within 24 hours." },
        { code: "02", name: "Planning", desc: "We define the team, tools and logistics. Travel, visas and safety briefings included." },
        { code: "03", name: "Deployment", desc: "Our crew is on site. Daily reports, clear escalation, professional conduct." },
        { code: "04", name: "Handover", desc: "Documented acceptance, punch list closed, handover to operations or OEM." },
      ],
    },
    models: {
      eyebrow: "ENGAGEMENTS · TRANSPARENT",
      title: "Three ways to work with us.",
      lead: "From a spot deployment to a permanent embedded crew — we scale with your need.",
      plans: [
        {
          name: "Spot deployment",
          price: "from CHF 990",
          unit: "/ day",
          desc: "One-off installation, maintenance or overhaul — short notice, no lock-in.",
          features: ["Response < 72h", "1–6 fitters", "Tools & logistics included", "Daily reports"],
        },
        {
          name: "Framework contract",
          price: "Custom",
          unit: "",
          desc: "Recurring maintenance windows or planned overhauls, fixed hourly rates.",
          features: ["Service calendar", "Priority availability", "Quarterly reporting", "24/7 escalation"],
          featured: true,
        },
        {
          name: "Embedded crew",
          price: "On request",
          unit: "",
          desc: "Permanently embedded fitters acting as an extension of your service org.",
          features: ["Dedicated team", "OEM training", "International travel", "DE · EN · ES"],
        },
      ],
    },
    about: {
      eyebrow: "ABOUT · SCHWEIZER PLANMANUFAKTUR GMBH",
      title: "We build what others design.",
      p1: "Schweizer Planmanufaktur GmbH is the assembly partner for makers of beverage equipment and machine tools across Germany, Switzerland and abroad — both within Europe and overseas.",
      p2: "Our fitters speak shop floor — and they speak with shift leaders, commissioning engineers and plant managers. Clean, on time, documented. Exactly as industry requires.",
      bullet_1: "Permanent in-house staff, no brokerage",
      bullet_2: "DE · CH · EU · overseas",
      bullet_3: "Tooling, travel and logistics included",
    },
    contact: {
      eyebrow: "CONTACT · NO COMMITMENT",
      title: "When does your crew need to be on site?",
      lead: "Send us asset, site and target dates. We respond within one business day with availability and day rates.",
      fields: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        company: "Company",
        project_type: "Engagement",
        message: "Asset, location, timeframe",
      },
      submit: "Send request",
      submitting: "Sending…",
      success: "Thank you! We'll get back to you within 24 hours.",
      error: "Something went wrong. Please try again.",
      info_title: "Head office",
      info_address: "Gründenstrasse 82, 8247 Flurlingen",
      info_hours: "Mon – Fri · 07:00 – 18:00 · 24/7 hotline",
      info_phone: "+41 52 551 01 40",
      info_email: "kontakt@schweizer-planmanufaktur.ch",
    },
    footer: {
      tagline: "Schweizer Planmanufaktur GmbH · Assemble · Build · Maintain.",
      rights: "All rights reserved.",
      imprint: "Imprint",
      privacy: "Privacy",
    },
    projectTypes: {
      "new-installation": "New installation",
      "maintenance": "Maintenance",
      "overhaul": "Overhaul",
      "modification": "Modification",
      "commissioning": "Commissioning",
      "service-partnership": "Service partnership",
      "other": "Other",
    },
  },
  es: {
    nav: {
      services: "Servicios",
      industries: "Sectores",
      process: "Proceso",
      models: "Modelos",
      about: "Nosotros",
      contact: "Contacto",
      cta: "Solicitar oferta",
    },
    hero: {
      eyebrow: "SOCIO DE MONTAJE · DE · CH · INTERNACIONAL",
      title_1: "Montar.",
      title_2: "Construir.",
      title_3: "Mantener.",
      subtitle:
        "Somos el pequeño taller para grandes plantas — especialistas en líneas de embotellado Krones, KHS y Tanner. Para cervecerías, refresqueras y embotelladoras de agua mineral. En Suiza, Alemania y a ultramar.",
      cta_primary: "Solicitar oferta",
      cta_secondary: "Ver servicios",
      stat_1_value: "3",
      stat_1_label: "Montadores en plantilla",
      stat_2_value: "15+",
      stat_2_label: "Años de experiencia",
      stat_3_value: "4",
      stat_3_label: "Continentes",
      stat_4_value: "24/7",
      stat_4_label: "Reacción ante paro",
    },
    services: {
      eyebrow: "SERVICIOS · 06 CAPACIDADES",
      title: "Del tornillo a la línea completa.",
      lead: "Sea el montaje de una línea de embotellado, la revisión de una máquina-herramienta o un mantenimiento urgente — aportamos mano, herramienta y criterio.",
      items: [
        { code: "01", name: "Nuevos montajes", desc: "Montaje integral in situ de líneas de embotellado, envasado y máquinas-herramienta." },
        { code: "02", name: "Mantenimiento", desc: "Mantenimiento programado según fabricante — puntual, documentado, en turnos." },
        { code: "03", name: "Revisiones", desc: "Revisiones generales con desmontaje, sustitución, ajuste y puesta en marcha." },
        { code: "04", name: "Modificaciones", desc: "Cambios de formato, retrofits y reconstrucciones — rápido, limpio, documentado." },
        { code: "05", name: "Puesta en marcha", desc: "Cold tests, hot tests y aceptaciones SAT en todo el mundo." },
        { code: "06", name: "Socio de servicio", desc: "Provisión permanente de montadores experimentados para OEM y cliente final." },
      ],
    },
    industries: {
      eyebrow: "SECTORES · 02 NÚCLEOS",
      title: "Dos mundos, un estándar: precisión bajo presión.",
      cards: [
        {
          tag: "SECTOR 01",
          name: "Industria de bebidas",
          desc: "Líneas de embotellado, etiquetadoras, sopladoras stretch-blow, paletizadoras. Conocemos la especificación — y el turno.",
          bullets: ["Embotellado y envasado", "Stretch-blow & PET", "Etiquetado y paletizado", "CIP / SIP higiene"],
          img: "https://images.unsplash.com/photo-1559059699-085698eba48c?auto=format&fit=crop&w=1400&q=80",
        },
        {
          tag: "SECTOR 02",
          name: "Máquinas-herramienta",
          desc: "Montaje, ajuste y modificación de centros de torneado, fresado y mecanizado. Hasta la micra.",
          bullets: ["Torneado y fresado", "Rectificado y EDM", "Integración de robots", "Medición geométrica"],
          img: "https://images.unsplash.com/photo-1565043666747-69f6646db940?auto=format&fit=crop&w=1400&q=80",
        },
      ],
    },
    process: {
      eyebrow: "PROCESO · CUATRO PASOS",
      title: "Definido. Ejecutado con limpieza.",
      steps: [
        { code: "01", name: "Solicitud", desc: "Comparta equipo, ubicación y plazo. Respondemos en firme en 24 horas." },
        { code: "02", name: "Planificación", desc: "Definimos equipo, herramienta y logística. Viajes, visados y formación de seguridad incluidos." },
        { code: "03", name: "Despliegue", desc: "Nuestro equipo está en obra. Partes diarios, escalado claro, conducta profesional." },
        { code: "04", name: "Entrega", desc: "Aceptación documentada, lista de reservas cerrada, handover a operaciones u OEM." },
      ],
    },
    models: {
      eyebrow: "MODELOS · TRANSPARENTES",
      title: "Tres formas de trabajar con nosotros.",
      lead: "Desde un despliegue puntual hasta un equipo permanente — escalamos con su necesidad.",
      plans: [
        {
          name: "Despliegue puntual",
          price: "desde CHF 990",
          unit: "/ día",
          desc: "Montaje, mantenimiento o revisión únicos — corto plazo, sin compromiso.",
          features: ["Reacción < 72 h", "1–6 montadores", "Herramienta y logística incluidas", "Partes diarios"],
        },
        {
          name: "Contrato marco",
          price: "A medida",
          unit: "",
          desc: "Mantenimientos recurrentes o ventanas de revisión planificadas, tarifa horaria fija.",
          features: ["Calendario de servicio", "Disponibilidad prioritaria", "Reporte trimestral", "Escalado 24/7"],
          featured: true,
        },
        {
          name: "Equipo embebido",
          price: "Consultar",
          unit: "",
          desc: "Montadores embebidos de forma permanente como extensión de su organización de servicio.",
          features: ["Equipo dedicado", "Formación OEM", "Viajes internacionales", "DE · EN · ES"],
        },
      ],
    },
    about: {
      eyebrow: "NOSOTROS · SCHWEIZER PLANMANUFAKTUR GMBH",
      title: "Tres montadores. 15 años. Cuatro continentes.",
      p1: "Somos un pequeño taller con tres montadores en plantilla — formados en cerrajería, montaje y electricidad, todos con más de 15 años de experiencia internacional en tecnología de embotellado de bebidas. Especializados en equipos de Krones, KHS y Tanner.",
      p2: "Trabajamos como solucionadores de problemas en nuevos montajes, mantenimientos y revisiones — en Suiza, Alemania y allí donde nos necesiten reconocidas cervecerías, refresqueras o embotelladoras de agua mineral. También en América, Australia o África. Sin intermediarios, sin subcontratistas — tres pares de manos que saben lo que hacen.",
      bullet_1: "Experiencia en Krones · KHS · Tanner",
      bullet_2: "DE · CH · América · Asia · África",
      bullet_3: "Herramienta, viajes y logística incluidos",
    },
    contact: {
      eyebrow: "CONTACTO · SIN COMPROMISO",
      title: "¿Cuándo necesita a su equipo en obra?",
      lead: "Envíenos equipo, ubicación y fechas. Respondemos en un día laborable con disponibilidad y tarifa.",
      fields: {
        name: "Nombre",
        email: "Correo",
        phone: "Teléfono",
        company: "Empresa",
        project_type: "Modelo",
        message: "Equipo, ubicación, plazo",
      },
      submit: "Enviar solicitud",
      submitting: "Enviando…",
      success: "¡Gracias! Le responderemos en 24 horas.",
      error: "Algo salió mal. Inténtelo de nuevo.",
      info_title: "Sede",
      info_address: "Gründenstrasse 82, 8247 Flurlingen",
      info_hours: "Lu – Vi · 07:00 – 18:00 · 24/7",
      info_phone: "+41 52 551 01 40",
      info_email: "kontakt@schweizer-planmanufaktur.ch",
    },
    footer: {
      tagline: "Schweizer Planmanufaktur GmbH · Montar · Construir · Mantener.",
      rights: "Todos los derechos reservados.",
      imprint: "Aviso legal",
      privacy: "Privacidad",
    },
    projectTypes: {
      "new-installation": "Nuevo montaje",
      "maintenance": "Mantenimiento",
      "overhaul": "Revisión",
      "modification": "Modificación",
      "commissioning": "Puesta en marcha",
      "service-partnership": "Socio de servicio",
      "other": "Otro",
    },
  },
};

export const supportedLanguages = [
  { code: "de", label: "DE" },
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

export const BRAND = {
  blue: "#1d428a",
  blueDeep: "#16336c",
  pink: "#df4661",
  pinkDeep: "#c63a55",
  light: "#e8ecf3",
  ink: "#0A0A0A",
  muted: "#5A6270",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_schweizer-plan/artifacts/l4o100zd_base_logo_transparent_background_RIP.png",
  logoAnimated: "https://customer-assets.emergentagent.com/job_schweizer-plan/artifacts/h559trn3_animation_sync_Contrast_wfrzctfyy.gif",
  promoVideo: "https://customer-assets.emergentagent.com/job_schweizer-plan/artifacts/bwwdbs5y_promo-video.mp4",
};
